import { generatePayslipPdf, updatePayslipStatus } from "@/api/payslips";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { usePayContext } from "@/context/PayContext";
import { toast } from "@/hooks/use-toast";
import { AggregatePayslip, ProcessingStatus } from "@/models/payslips.model";
import { ViewPayslipPdfActionCell } from "@/staff/payslip/payslip-data-table/columns";
import { ColumnDef } from "@tanstack/react-table";
import {
  ArrowUpDown,
  FileText,
  MoreHorizontal,
  Pencil,
  Undo2,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

export const columns: ColumnDef<AggregatePayslip>[] = [
  {
    id: "user",
    accessorFn: (row) => `${row.userDetails.name}`,
    cell: ({ row }) => row.original.userDetails.name,
    header: ({ column }) => {
      return (
        <div className="flex items-center gap-2">
          Emloyee
          <button
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </button>
        </div>
      );
    },
  },
  {
    header: "Gross Pay",
    cell: ({ row }) => row.original.grossPay,
  },
  {
    header: "Employee CPF",
    cell: ({ row }) => row.original.totalEmployeeCpfContribution,
  },
  {
    header: "Net Pay",
    cell: ({ row }) => row.original.netPay,
  },
  {
    header: "Other Items",
    cell: ({ row }) => row.original.otherItems,
  },
  {
    header: "Net Payable",
    cell: ({ row }) => row.original.netPayable,
  },
  {
    header: "Actions",
    cell: ({ row }) => <ViewPayslipPdfActionCell row={row} />,
  },
];
